<div *ngIf="!submitted || submitting">
    <H1>ETConnect User Account Request Form - TIPS</H1>

    <form #form="ngForm">
        <div fxLayout="column">           
            <mat-card>
                <mat-card-title>Action Requested</mat-card-title>
                <mat-card-content>
                    <cad-lib-radio 
                    matTooltip
                    [resultProperty]="'code'"
                    [displayProperty]="'description'"
                    [data]="actionOptions"
                    [(selectValue)]="data.actionCd"
                    fxFlex></cad-lib-radio>   
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-title>User Information</mat-card-title>
                <mat-card-content>

                <div fxFlex fxLayout="column" *ngIf="data.actionCd!='remove'">
                    <div fxFlex col-span="2" fxLayout="column" *ngIf="data.actionCd!='add'" >
                        <mat-form-field>
                            <mat-label>Current ETConnect ID</mat-label>
                            <input matInput
                            [(ngModel)]="data.userId"
                            name="userId"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em">
                        <mat-form-field fxFlex>
                            <mat-label>Company Name</mat-label>
                            <input matInput
                            [(ngModel)]="data.companies[0].companyName"
                            name="companyName"
                            required
                            maxlength="60"
                            />
                        </mat-form-field>
                        <mat-form-field fxFlex>
                            <mat-label>BA Number</mat-label>
                            <input matInput
                            type="number"
                            [(ngModel)]="data.companies[0].companyId"
                            name="companyId"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em">
                        <mat-form-field fxFlex>
                            <mat-label>First Name</mat-label>
                            <input matInput
                            [(ngModel)]="data.firstName"
                            name="firstName"
                            minlength="2"
                            maxlength="30"
                            required
                            />
                        </mat-form-field>
                        <mat-form-field fxFlex>
                            <mat-label>Last Name</mat-label>
                            <input matInput
                            [(ngModel)]="data.lastName"
                            name="lastName"
                            minlength="2"
                            maxlength="30"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em">
                        <mat-form-field fxFlex>
                            <mat-label>Email</mat-label>
                            <input matInput
                            emailAddress
                            [(ngModel)]="data.email"
                            name="email"
                            required
                            />
                        </mat-form-field>
                        <mat-form-field fxFlex>
                            <mat-label>Phone</mat-label>
                            <input matInput
                            [(ngModel)]="data.phone"
                            name="phone"
                            mask="(000) 000-0000"
                            required
                            />
                        </mat-form-field>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-title>Manager Information</mat-card-title>
            <mat-card-content>
                <div fxLayout="column" *ngIf="data.actionCd!='remove'">
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em">
                        <mat-form-field fxFlex>
                            <mat-label>Manager Name</mat-label>
                            <input matInput
                            [(ngModel)]="data.managerName"
                            name="managerName"
                            minlength="4"
                            maxlength="60"
                            required
                            />
                        </mat-form-field>
                        <mat-form-field fxFlex>
                            <mat-label>Manager Phone</mat-label>
                            <input matInput
                            [(ngModel)]="data.managerPhone"
                            name="managerPhone"
                            mask="(000) 000-0000"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex>
                        <mat-form-field fxFlex>
                            <mat-label>Manager Email</mat-label>
                            <input matInput
                            emailAddress
                            [(ngModel)]="data.managerEmail"
                            name="managerEmail"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <mat-checkbox required matInput name="legalAcceptInd" [(ngModel)]="data.legalAcceptInd">
                        <b>{{data.companies[0].companyName ? data.companies[0].companyName : '&lt;Company Name&gt;'}} accepts responsibility for this account's transactions on ETConnect. Company must hold a valid transportation contract on the Plants or Facilities selected below to have access to those modules on ETConnect.</b>
                    </mat-checkbox>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-title>Plant or Facility Name(s)</mat-card-title>
            <mat-card-content>
                <div fxLayout="column" *ngFor="let plantFacility of data.plantFacilities; let i = index; trackBy: trackByKey">
                    <div *ngIf="i % 3 === 0" fxLayout="row" fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em">
                        <div fxFlex *ngFor="let j of [0, 1, 2]; trackBy: trackByKey">
                            <mat-form-field fxFlex>
                                <mat-label>Name</mat-label>
                                <input matInput
                                [(ngModel)]="data.plantFacilities[i + j].plantFacilityName"
                                [name]="'plantFacility' + i + j"
                                (blur)="onPlantFacilityNameBlur($event)"
                                minlength="4"
                                maxlength="100"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        
        <mat-card>
            <mat-card-title>Access Information</mat-card-title>
            <mat-card-content>
                <div fxLayout="column" *ngIf="data.actionCd!='remove'">
                    <div fxFlex fxLayout="row" fxLayoutGap="1em" class="access-selections">
                        <div fxFlex="fill"><h3>Access:</h3></div>
                    </div>
                    <div fxFlex fxLayout="row wrap" fxLayoutGap="1em">
                        <div fxFlex="fill" fxLayoutWrap="true" *ngFor="let r of roles">
                            <mat-checkbox fxLayoutAlign="end" class="access-check" matInput [name]="r.code" labelPosition="before" (change)="checkSelected($event, r.code, 'roles')" [(ngModel)]="r.checked">{{r.description}}</mat-checkbox>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <mat-card>
        <mat-card-content>
            <div>
                <!-- <re-captcha (resolved)="captchaResolved($event)"></re-captcha> -->
                <!-- <re-captcha [(ngModel)]="captcha" name="captcha" required #captchaControl="ngModel"></re-captcha> -->
                <!-- <re-captcha (resolved)="resolved($event)" (errored)="onError($event)" errorMode="handled"></re-captcha> -->
                <re-captcha id="recaptcha" name="recaptcha" #recaptcha="ngModel" 
                [(ngModel)]="data.recaptchaToken" required 
                [class.is-invalid]="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)"></re-captcha>
            </div>
            <div fxLayout="row" fxLayoutAlign="left">
                <div fxFlex fxLayoutAlign="start">
                    <button style="margin-right: 8px;" type="submit" mat-raised-button color="primary" [disabled]="submitted || !form.form.valid || recaptcha.invalid || data.roles.length === 0 || !areAnyPlantFacilityNamesSet" (click)="submit()">Submit Request</button>
                    <button mat-raised-button (click)="clear()">Clear</button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
                 

    </form>
    <div class="loading" *ngIf="submitting">
        <mat-spinner></mat-spinner>
    </div>
</div>
<div *ngIf="submitted && !submitting">
    <car-submit-successful [name]="data.firstName" (submitAnother)="clear()"></car-submit-successful>
</div>